import { render, staticRenderFns } from "./BattlesItemElement.vue?vue&type=template&id=5f8ecce1&scoped=true"
import script from "./BattlesItemElement.vue?vue&type=script&lang=js"
export * from "./BattlesItemElement.vue?vue&type=script&lang=js"
import style0 from "./BattlesItemElement.vue?vue&type=style&index=0&id=5f8ecce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ecce1",
  null
  
)

export default component.exports